// deno-fmt-ignore-file
export function FromBase(context, type, value) {
    return type.Clean(value);
}
